module.exports = __webpack_public_path__ + "media/images/course/1-15a72700acfb9c8f86e78d5bf5407f0d.png";